module.exports = __webpack_public_path__ + "img/box-item-icon2.46a4ad1e.png";